import React from 'react';
import styles from './Login.module.css'
import {SignInButton} from "@clerk/clerk-react";

export const Login = () => {

    return <div className={styles.page}>
        <span className={styles.title}>Welcome to Motortech Platform</span>
        <SignInButton>
            <div className={styles.button}>
                <span className={styles.buttonTitle}>Sign In</span>
            </div>
        </SignInButton>
    </div>
}
